import Vue from 'vue';
import VueRouter from 'vue-router';

import ChangeEmail from '@/components/ChangeEmail.vue';
import ConfirmAccount from '@/components/ConfirmAccount.vue';
import ConfirmEmail from '@/components/ConfirmEmail.vue';
import ErrorPage from '@/components/ErrorPage.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/confirm-account',
    component: ConfirmAccount,
    name: 'ConfirmAccount',
    meta: {
      title: 'Confirm Account'
    }
  },
  {
    path: '/confirm-email',
    component: ConfirmEmail,
    name: 'ConfirmEmail',
    meta: {
      title: 'Confirm Email'
    }
  },
  {
    path: '/change-email',
    component: ChangeEmail,
    name: 'ChangeEmail',
    meta: {
      title: 'Change Email'
    }
  },
  {
    path: '/credentials/forgot-password',
    component: ForgotPassword,
    name: 'ForgotPassword',
    meta: {
      title: 'Forgot Password'
    }
  },
  {
    path: '/error',
    component: ErrorPage,
    name: 'ErrorPage',
    meta: {
      title: 'Error'
    },
    children: [
      {
        path: 'login-link',
        meta: {
          header: 'reviewLoginLinkError',
          title: 'Review Login Error'
        }
      }
    ]
  }
];

const router = new VueRouter({
  routes,
  base: '/',
  mode: 'history'
});

const DEFAULT_TITLE = 'Authorization';

router.beforeEach((to, from, next) => {
  document.title = DEFAULT_TITLE;
  if (to && to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
